// extracted by mini-css-extract-plugin
export default {"tagInputContainer":"Lwag5o2dYPNQgTqiptyg","tagChipsContainer":"v5MAoJrrlUKgU9sCYCXR"};